import { DataBean } from "../DataBean";

export class WorkActivitySubtask extends DataBean {

  public async getWorkActivitySubtaskCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivitySubtaskCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteWorkActivitySubtask(idworkactivitysubtask: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivitySubtask_Number",
      [idworkactivitysubtask]
    );
  }

  public async updateWorkActivitySubtask(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivitySubtask_updateWorkActivitySubtask_com.advantage.processflow.bean.WorkActivitySubtask",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivitySubtask",
        },
      ]
    );
  }
}
